import MultiSelectCheckbox from './MultiSelectCheckbox.component';

export default MultiSelectCheckbox;